import { useContext, useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import {Checkbox, Dialog,FormControl,FormHelperText,IconButton,InputLabel,ListItemText,MenuItem,Select,TextField,Tooltip} from "@material-ui/core";
import { Box } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReportContext, { Types } from "../../../context/ReportsContext/ReportContext";
import AddTable from "../../../screens/Colaboradores/Colaboradores/CollaboratorTab/AddTable";
import { CREATE_CUSTOM_REPORT, GET_DATACOLUMNS, GET_DATASOURCE } from "../../../Querys/querys";
import styles from "../css/CreateReports.module.css";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { useHistory } from "react-router-dom";

const validationSchema = () => {
  return {
    reportName: Yup.string().required("Obligatorio"),
    description: Yup.string().required("Obligatorio"),
    datasources: Yup.array().required("Obligatorio").test("dataSources", "Selecciona al menos una fuente de datos.", function (value) {
      return !(value === undefined || value.length === 0);
    }),
    rows: Yup.array().required("Obligatorio").test("areas", "Selecciona al menos un campo.", function (value) {
      return !(value === undefined || value.length === 0);
    }),
    columns: Yup.array().required("Obligatorio").test("areas", "Selecciona al menos un campo por ordenar.", function (value) {
      return !(value === undefined || value.length === 0);
    }),
  }
};

interface Option {
  id: number;
  name: string;
  column: string;
}

interface Row {
  category: string;
  tableId: number;
  tableName: string;
  options: Option[];
}

interface FormDatasource {
  id: number;
  Name: string;
  Tables: string;
}

interface FormRow {
  id: number;
  name: string;
  column: string;
  tableId: number;
  tableName: string;
}

interface FormValues {
  reportName: string;
  description: string;
  datasources: FormDatasource[];
  rows: FormRow[];
  columns: FormRow[];
  pivot: FormRow[];
  //filters: any[];
}

const CreateReportModal = () => {
  const history = useHistory();
  const { state, dispatch } = useContext(ReportContext);
  const { data: dataSources } = useQuery(GET_DATASOURCE);
  const { data: dataColumns } = useQuery(GET_DATACOLUMNS);  
  const [createCustomReport] = useMutation<{
    variables: {
      input: {
        name: string;
        description: string;
        rows?: any[];
        columns?: any[];
      }
    }
  }>(CREATE_CUSTOM_REPORT);

  const formik = useFormik<FormValues>({
    initialValues: {
      reportName: '',
      description: '',
      datasources: [],
      rows: [],
      columns: [],
      pivot: [],
      //filters: [],
    },
    enableReinitialize: true,
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (formData, { resetForm }) => {
      let filterJson = null
      const name = formData.reportName;
      const description = formData.description;
      const rows = formData.rows.map((row) => ({
        idColumn: parseInt(row.id as any, 10),
        column: row.column,
        columnName: row.name,
        idDataSource: parseInt(dataSources.GET_DATASOURCE.find((x: any) => x.id === row.tableId)?.id, 10),
        dataSource: dataSources.GET_DATASOURCE.find((x: any) => x.Tables === row.tableName)?.Tables,
        isPivot: false,
        show: true,
      }));
      const columns = formData.columns.map((row) => ({
        idColumn: parseInt(row.id as any, 10),
        column: row.column,
        columnName: row.name,
        idDataSource: parseInt(dataSources.GET_DATASOURCE.find((x: any) => x.id === row.tableId)?.id, 10),
        dataSource: dataSources.GET_DATASOURCE.find((x: any) => x.Tables === row.tableName)?.Tables,
        isPivot: false,
        show: true,
      }));

      if (formData.pivot.length > 0) {
        formData.pivot.forEach((pivotItem) => {
          const existingRow = rows.find((row) => row.idColumn === parseInt(pivotItem?.id as any, 10));
          const existingColumn = columns.find((column) => column.idColumn === parseInt(pivotItem?.id as any, 10));

          if (existingRow) {
            existingRow.isPivot = true;
          } else if (existingColumn) {
            existingColumn.isPivot = true;
          } else if (rows?.length > 0) {
            rows.push({
              idColumn: parseInt(pivotItem?.id as any, 10),
              column: pivotItem?.column,
              columnName: pivotItem?.name,
              idDataSource: parseInt(dataSources.GET_DATASOURCE.find((x: any) => x.id === pivotItem?.tableId)?.id, 10),
              dataSource: dataSources.GET_DATASOURCE.find((x: any) => x.Tables === pivotItem?.tableName)?.Tables,
              isPivot: true,
              show: false,
            });
          } else if (columns?.length > 0) {
            columns.push({
              idColumn: parseInt(pivotItem?.id as any, 10),
              column: pivotItem?.column,
              columnName: pivotItem?.name,
              idDataSource: parseInt(dataSources.GET_DATASOURCE.find((x: any) => x.id === pivotItem?.tableId)?.id, 10),
              dataSource: dataSources.GET_DATASOURCE.find((x: any) => x.Tables === pivotItem?.tableName)?.Tables,
              isPivot: true,
              show: false,
            });
          }
        });
      }

      if(formData.columns.length > 0){
        const filters = formik.values.columns.reduce((componet: any, value:any) => (componet[value.name] = '', componet) , {});
        filterJson = JSON.stringify(filters)
      }

      await createCustomReport({
        variables: {
          input: {
            name,
            description,
            ...(rows?.length > 0 && { rows }),
            ...(columns?.length > 0 && { columns }),
            ...(filterJson != null && {filterJson})
          }
        }
      })
      resetForm();
      setFilteredColumns([])
      setFilteredRows([])
      setFilteredPivots([])
      setFilteredFilters([])
      setInitFilteredColumns([]);
      setInitFilteredRows([]);
      setInitFilteredPivots([]);
      setInitFilteredFilters([]);
      setOrderedFilters([]);
      dispatch({
        type: Types.CLOSE_CREATE_REPORTS
      });
      SuccessfulAlert({ text: "Se ha creado el informe correctamente" });
    }
  });
  
  const [datasSourcers, setDatasSourcers] = useState<any[]>([]);
  const [initDataSources, setInitDataSources] = useState<any[]>([]);
  const [columns, setColumns] = useState<Row[]>([]);
  const [rows, setRows] = useState<Row[]>([]);
  const [pivots, setPivots] = useState<Row[]>([]);
  const [filteredColumns, setFilteredColumns] = useState<Row[]>([]);
  const [filteredRows, setFilteredRows] = useState<Row[]>([]);
  const [filteredPivots, setFilteredPivots] = useState<Row[]>([]);
  const [initFilteredColumns, setInitFilteredColumns] = useState<Row[]>([]);
  const [initFilteredRows, setInitFilteredRows] = useState<Row[]>([]);
  const [initFilteredPivots, setInitFilteredPivots] = useState<Row[]>([]);
  const [filteredFilters, setFilteredFilters] = useState<Row[]>([]);
  const [initFilteredFilters, setInitFilteredFilters] = useState<Row[]>([]);
  const [orderedFilters, setOrderedFilters] = useState<Row[]>([]);

  useEffect(() => {
    if (dataSources?.GET_DATASOURCE?.length > 0 && dataColumns?.GET_DATACOLUMNS?.length > 0) {
      const result: any = [];

      dataSources?.GET_DATASOURCE?.forEach((table: any) => {
        const options = dataColumns?.GET_DATACOLUMNS
        ?.filter((column: any) => column.table === table.Tables)
        ?.map((column: any) => ({ id: column.id, name: column.Name, column: column.column }));
          
        const sortedOptions = options?.slice().sort((a: any, b: any) => {
          const aHas = /id/i.test(String(a.name));
          const bHas = /id/i.test(String(b.name));
          if (aHas && !bHas) return -1;
          if (!aHas && bHas) return 1;
            return String(a.name).localeCompare(String(b.name), undefined, { sensitivity: 'base' });
        }) ?? [];

        const categoryObj = {
          category: table.Name,
          tableId: table.id,
          tableName: table.Tables,
          options: sortedOptions
          
        };
        result.push(categoryObj);
      });
      
      setRows(result);
      setColumns(result);
      setPivots(result);
      setDatasSourcers(dataSources?.GET_DATASOURCE)
      setInitDataSources(dataSources?.GET_DATASOURCE)

    }
  }, [dataSources, dataColumns])

  const closeModal = () => {
    dispatch({
      type: Types.CLOSE_CREATE_REPORTS
    })
    formik.resetForm();
    setFilteredColumns([]);
    setFilteredRows([]);
    setFilteredPivots([]);
    setFilteredFilters([]);
    setInitFilteredColumns([]);
    setInitFilteredRows([]);
    setInitFilteredPivots([]);
    setInitFilteredFilters([]);
    setOrderedFilters([]);
  };

  const goToPreview = async () => {
    const errors = await formik.validateForm()
    if(Object.keys(errors).length !== 0){
      formik.submitForm();
      return
    }
    let filterJson = null
    const name = formik.values.reportName;
    const description = formik.values.description;
    const rows = formik.values.rows.map((row) => ({
      idColumn: parseInt(row.id as any, 10),
      column: row.column,
      columnName: row.name,
      idDataSource: parseInt(dataSources.GET_DATASOURCE.find((x: any) => x.id === row.tableId)?.id, 10),
      dataSource: dataSources.GET_DATASOURCE.find((x: any) => x.Tables === row.tableName)?.Tables,
      isPivot: false,
      show: true,
    }));
    const columns = formik.values.columns.map((row) => ({
      idColumn: parseInt(row.id as any, 10),
      column: row.column,
      columnName: row.name,
      idDataSource: parseInt(dataSources.GET_DATASOURCE.find((x: any) => x.id === row.tableId)?.id, 10),
      dataSource: dataSources.GET_DATASOURCE.find((x: any) => x.Tables === row.tableName)?.Tables,
      isPivot: false,
      show: true,
    }));

    if(formik.values.rows.length > 0){
      const filters = formik.values.rows.reduce((componet: any, value:any) => (componet[value.name] = '', componet) , {});
      filterJson = JSON.stringify(filters)
    }
  
    if (formik.values.pivot.length > 0) {
      formik.values.pivot.forEach((pivotItem) => {
        const existingRow = rows.find((row) => row.idColumn === parseInt(pivotItem.id as any, 10));
        const existingColumn = columns.find((column) => column.idColumn === parseInt(pivotItem.id as any, 10));

        if (existingRow) {
          existingRow.isPivot = true;
        } else if (existingColumn) {
          existingColumn.isPivot = true;
        } else if (rows?.length > 0) {
          rows.push({
            idColumn: parseInt(pivotItem.id as any, 10),
            column: pivotItem.column,
            columnName: pivotItem.name,
            idDataSource: parseInt(dataSources.GET_DATASOURCE.find((x: any) => x.id === pivotItem.tableId)?.id, 10),
            dataSource: dataSources.GET_DATASOURCE.find((x: any) => x.Tables === pivotItem.tableName)?.Tables,
            isPivot: true,
            show: false,
          });
        } else if (columns?.length > 0) {
          columns.push({
            idColumn: parseInt(pivotItem.id as any, 10),
            column: pivotItem.column,
            columnName: pivotItem.name,
            idDataSource: parseInt(dataSources.GET_DATASOURCE.find((x: any) => x.id === pivotItem.tableId)?.id, 10),
            dataSource: dataSources.GET_DATASOURCE.find((x: any) => x.Tables === pivotItem.tableName)?.Tables,
            isPivot: true,
            show: false,
          });
        }
      });
    }

    dispatch({
      type: Types.PREVIEW_DATA,
      payload: {
        name,
        description,
        rows,
        columns,
        filterJson,
      }
    })

    dispatch({
      type: Types.CLOSE_CREATE_REPORTS
    })
    history.push('/informes/preview');
  }

  // Filtrado para el orden de columnas.
  const handleOrderColumnsFilter = (selectedRows : any) => { 
    const newFilteredRows = [...filteredRows]
    const filters =  newFilteredRows.filter((row) => selectedRows.some((selected: any) => selected.id === row.tableId));
    setOrderedFilters(filters);
    if (!newFilteredRows || newFilteredRows.length === 0) {
      setOrderedFilters([]);
      return;
    }
    const selectedIds = new Set(selectedRows.map((s: any) => String(s.id)));
    const result: Row[] = filteredRows.reduce((acc: Row[], row) => {
      const matchedOptions = row.options.filter((opt) => selectedIds.has(String(opt.id)));
      if (matchedOptions.length > 0) {
        acc.push({
          ...row,
          options: matchedOptions,
        });
      }
      return acc;
    }, []);

    setOrderedFilters(result);
  }

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={state.createModalReports}
      fullWidth
    >
      <div className={styles.mainBox}>
        <div className={styles.mainContainer}>
          <button
            className={styles.closeModalButton}
            onClick={closeModal}
          >
            <img src ='/../../../assets/svg/CloseM.svg'/>
          </button>
        </div>
        <h2 id="form-dialog-title" className="text-center">
          Crear informe
        </h2>

        <form onSubmit={formik.handleSubmit}>
          <div>
            <TextField
              type="text"
              name="reportName"
              label="Nombre del informe *"
              variant="outlined"
              size="small"
              fullWidth={true}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.reportName}
              error={formik.touched.reportName && Boolean(formik.errors.reportName)}
              helperText={formik.touched.reportName && formik.errors.reportName}
              inputProps={{ maxLength: 100 }}
              className={styles.textFieldSpacing}
            />
          </div>
          <div>
          </div>
          <div className={styles.textFieldSpacing}>
            <TextField
              type="text"
              name="description"
              label="Descripción *"
              variant="outlined"
              size="small"
              fullWidth={true}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.description}
              error={formik.touched.description && Boolean(formik.errors.description)}
              helperText={formik.touched.description && formik.errors.description}
              inputProps={{ maxLength: 100 }}
            /> 
          </div>
          <div className={styles.formControlContainer}>

            { /* FormControl fuente de datos */}
            <FormControl
              size="small"
              variant="outlined"
              className="question"
              style={{
                width: '48%'
              }}
            >
              <InputLabel id="datasources" className={styles.formLabel}>
                Fuente de datos*
              </InputLabel>
              <Select
                className={styles.select}
                startAdornment={
                  <Tooltip title="Información adicional sobre las fuentes de datos">
                    <IconButton aria-label="info">
                      <img src="/assets/svg/info.svg" alt="Información" />
                    </IconButton>
                  </Tooltip>
                }
                onClose={() => setDatasSourcers(initDataSources)}
                value={formik.values.datasources}
                labelId="datasources"
                id="datasources"
                name="datasources"
                placeholder="Fuente de datos *"
                multiple
                renderValue={(selected: any) => selected.map((x: any) => x.Name).join(', ')}
                error={formik.touched.datasources && Boolean(formik.errors.datasources)}
                MenuProps={{ autoFocus: false }}
              >
                
                {
                  datasSourcers.length > 0 && (
                    <MenuItem value={'all'}>
                      <Checkbox
                        style={{
                          color: "#FABB00",
                        }}
                        checked={
                          formik.values.datasources.length === dataSources?.GET_DATASOURCE?.length
                        }
                        onChange={() => {
                          if (formik.values.datasources.length === dataSources?.GET_DATASOURCE?.length) {
                            formik.setFieldValue("datasources", []);
                            formik.setFieldValue("rows",[]);
                            formik.setFieldValue("columns",[]);
                            formik.setFieldValue("pivot",[]);
                            setFilteredColumns([]);
                            setFilteredRows([]);
                            setFilteredPivots([]);
                            setFilteredFilters([])
                            setInitFilteredColumns([]);
                            setInitFilteredRows([]);
                            setInitFilteredPivots([]);
                            setInitFilteredFilters([])

                          } else {
                            formik.setFieldValue("datasources", dataSources?.GET_DATASOURCE);
                            setFilteredColumns(columns);
                            setFilteredRows(rows);
                            setFilteredPivots(pivots);
                            setFilteredFilters(rows)
                            setInitFilteredColumns(columns);
                            setInitFilteredRows(rows);
                            setInitFilteredPivots(pivots);
                            setInitFilteredFilters(rows)
                          }
                        }}
                      />
                      <ListItemText>
                        <span className={styles.checkboxLabel}>Seleccionar todo</span>
                      </ListItemText>
                    </MenuItem>
                  )
                }
                {
                  datasSourcers.length > 0 && datasSourcers.map((item: any) => (
                    <MenuItem key={item.id} value={item.id}>
                      <Checkbox
                        style={{
                          color: "#FABB00",
                        }}
                        checked={formik.values.datasources.some(((x: any) => x.id === item.id))}
                        onChange={() => {
                          if (formik.values.datasources.some(((x: any) => x.id === item.id))) {
                            const updatedSelection = formik.values.datasources.filter(
                              (tim: any) => tim.id !== item.id
                            );
                            formik.setFieldValue("datasources", updatedSelection);
                            setFilteredColumns(filteredColumns.filter((x) => x.tableId !== item.id));
                            setFilteredRows(filteredRows.filter((x) => x.tableId !== item.id));
                            setFilteredPivots(filteredPivots.filter((x) => x.tableId !== item.id));
                            setFilteredFilters(filteredFilters.filter((x) =>x.tableId !== item.id));
                            setInitFilteredColumns(filteredColumns.filter((x) => x.tableId !== item.id));
                            setInitFilteredRows(filteredRows.filter((x) => x.tableId !== item.id));
                            setInitFilteredPivots(filteredPivots.filter((x) => x.tableId !== item.id));
                            setInitFilteredFilters(filteredFilters.filter((x) =>x.tableId !== item.id));
                            
                            if(formik.values.rows.length > 0){
                              const updateRowsSelection = formik.values.rows.filter(
                                (fila: any) => fila.tableId !== item?.id
                              )
                              formik.setFieldValue("rows", updateRowsSelection)
                            }

                            if(formik.values.columns.length > 0){
                              const updateColumnsSelection = formik.values.columns.filter(
                                (column: any) => column?.tableId !== item?.id
                                )
                                formik.setFieldValue("columns",updateColumnsSelection)
                            }

                            if(formik.values.pivot.length > 0){
                              const updatePivotsSelection = formik.values.pivot.filter(
                                (pivot: any) => pivot?.tableId !== item?.id
                              )
                              formik.setFieldValue("pivot", updatePivotsSelection)
                            }

                            if(formik.values.columns.length > 0){
                              const updateFiltersSelection = formik.values.columns.filter(
                                (fils: any) => fils?.tableId !== item?.id
                              )
                              
                              formik.setFieldValue("filters", updateFiltersSelection)
                            }

                          } else {
                            const updatedSelection = [...formik.values.datasources, item];
                            formik.setFieldValue("datasources", updatedSelection);
                            setFilteredColumns([...filteredColumns, ...columns.filter((x) => x.tableId === item.id)]);
                            setFilteredRows([...filteredRows, ...rows.filter((x) => x.tableId === item.id)]);
                            setFilteredPivots([...filteredPivots, ...pivots.filter((x) => x.tableId === item.id)]);
                            setFilteredFilters([...filteredFilters, ...rows.filter((x) => x.tableId === item.id)]);
                            setInitFilteredColumns([...filteredColumns, ...columns.filter((x) => x.tableId === item.id)]);
                            setInitFilteredRows([...filteredRows, ...rows.filter((x) => x.tableId === item.id)]);
                            setInitFilteredPivots([...filteredPivots, ...pivots.filter((x) => x.tableId === item.id)])
                            setInitFilteredFilters([...filteredFilters, ...rows.filter((x) => x.tableId === item.id)]);
                          }
                        }}
                      />
                      <ListItemText>
                        <span className={styles.checkboxLabel}>{item.Name}</span>
                      </ListItemText>
                    </MenuItem>
                  ))
                }
              </Select>

              <FormHelperText style={{ color: "red" }}>
                {formik.touched.datasources && formik.errors.datasources}
              </FormHelperText>
            </FormControl>

            { /* FormControl campos */}
            <FormControl
              size="small"
              variant="outlined"
              className="question"
              style={{
                width: '48%'
              }}
            >
              <InputLabel id="columns" className={styles.formLabel}>
                Campos *
              </InputLabel>

              <Select
                className={styles.select}
                startAdornment={
                  <Tooltip title="Información adicional sobre los campos">
                    <IconButton aria-label="info">
                      <img src="/assets/svg/info.svg" alt="Información" />
                    </IconButton>
                  </Tooltip>
                }
                onClose={() => setFilteredColumns(initFilteredColumns)}
                value={formik.values.columns}
                labelId="columns"
                id="columns"
                name="columns"
                placeholder="Campos *"
                multiple
                renderValue={(selected: any) => selected.map((x: any) => x.name).join(', ')}
                error={formik.touched.columns && Boolean(formik.errors.columns)}
              >
                { /* item campos: Seleccionar todo */ }
                {filteredColumns.length > 0 && (
                  <MenuItem value={'all'}>
                    <Checkbox
                      style={{ color: "#FABB00" }}
                      checked={
                        (() => {
                          const allOptions = filteredColumns.flatMap(c =>
                            c.options.map((opt: any) => ({ ...opt, tableName: c.tableName, tableId: c.tableId }))
                          );
                          return allOptions.length > 0 && formik.values.columns.length === allOptions.length;
                        })()
                      }
                      onChange={() => {
                        const allOptions = filteredColumns.flatMap(c =>
                          c.options.map((opt: any) => ({ ...opt, tableName: c.tableName, tableId: c.tableId }))
                        );
                        if (formik.values.columns.length === allOptions.length) {
                          formik.setFieldValue("columns", []);
                          setOrderedFilters([]);
                        } else {
                          formik.setFieldValue("columns", allOptions);
                          handleOrderColumnsFilter(allOptions);
                        }
                      }}
                    />
                    <ListItemText>
                      <span className={styles.checkboxLabel}>Seleccionar todo</span>
                    </ListItemText>
                  </MenuItem>
                )}

                { /* item campos: Selección individual */ }
                {filteredColumns.map((item) => (
                  <Box key={`colum${item.tableId}`}>
                    <div
                      className={styles.checkboxLabel}
                      style={{
                        marginTop: '1rem',
                        paddingLeft: '1rem',
                      }}>{item.category}
                    </div>

                    {
                      item.options.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          <Checkbox
                            style={{
                              color: "#FABB00",
                            }}
                            checked={formik.values.columns.some(((x) => x?.id === option?.id))}
                            onChange={() => {
                              if (formik.values.columns.some(((x) => x?.id === option?.id))) {
                                const updatedSelection = formik.values.columns.filter(
                                  (itm) => itm?.id !== option?.id
                                );
                                formik.setFieldValue("columns", updatedSelection);
                                handleOrderColumnsFilter(updatedSelection);
                              } else {
                                const updatedSelection = [
                                  ...formik.values.columns,
                                  { ...option, tableName: item.tableName, tableId: item.tableId }
                                ];
                                formik.setFieldValue("columns", updatedSelection);
                                handleOrderColumnsFilter(updatedSelection);
                              }
                            }}

                          />
                          <ListItemText>
                            <span className={styles.checkboxLabel}>{option.name}</span>
                            {console.log('optionName', option.name)}
                          </ListItemText>

                        </MenuItem>
                      ))
                    }
                  </Box>
                ))}

              </Select>

              <FormHelperText style={{ color: "red" }}>
                {formik.touched.columns && formik.errors.columns}
              </FormHelperText>

            </FormControl>
            
            { /* FormControl orden de campos */}
            {/* 
            <FormControl
              size="small"
              variant="outlined"
              className="question"
              style={{
                width: '30%',
              }}
            >
              <InputLabel id="rows" className={styles.formLabel}>
                Orden de los campos *
              </InputLabel>
              <Select
                className={styles.select}
                startAdornment={
                  <Tooltip title="Información adicional sobre el orden de los campos">
                    <IconButton aria-label="info">
                      <img src="/assets/svg/info.svg" alt="Información" />
                    </IconButton>
                  </Tooltip>
                }
                onClose={() => setFilteredRows(initFilteredRows)}
                value={formik.values.rows}
                labelId="rows"
                id="rows"
                name="rows"
                placeholder="Orden de los campos *"
                multiple
                renderValue={(selected: any) => selected.map((x: any) => x.name).join(', ')}
                error={formik.touched.rows && Boolean(formik.errors.rows)}
              >
                
                {orderedFilters.map((item) => (
                  <Box key={`row${item.tableId}`}>
                    <div
                      className={styles.checkboxLabel}
                      style={{
                        marginTop: '1rem',
                        paddingLeft: '1rem',
                      }}
                    >
                      {item.category}
                    </div>
                    {item.options.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        <Checkbox
                          style={{
                            color: "#FABB00",
                          }}
                          checked={formik.values.rows.some(((x) => x.id === option.id))}
                          onChange={() => {
                            if (formik.values.rows.some(((x) => x.id === option.id))) {
                              const updatedSelection = formik.values.rows.filter(
                                (itm) => itm.id !== option.id
                              );
                              formik.setFieldValue("rows", updatedSelection);
                            } else {
                              const updatedSelection = [
                                ...formik.values.rows,
                                { ...option, tableName: item.tableName, tableId: item.tableId }
                              ];
                              formik.setFieldValue("rows", updatedSelection);
                            }
                          }}
                        />
                        <ListItemText>
                          <span className={styles.checkboxLabel}>{option.name}</span>
                        </ListItemText>
                      </MenuItem>
                    ))}
                  </Box>
                ))}
              </Select>
              <FormHelperText style={{ color: "red" }}>
                {formik.touched.rows && formik.errors.rows}
              </FormHelperText>
            </FormControl>   
            */}
          </div>
          <div className={styles.formControlContainer}>
            <button className={styles.cancelButton}
              type="button" onClick={closeModal}>Cancelar
            </button>
            <AddTable
              func={() => console.log('func')}
              text="Crear informe"
              img="report-icon.svg"
              type="submit"
            />
            <AddTable
              func={goToPreview}
              text="Vista previa"
              img="report-icon.svg"
              type="button"
            />
          </div>
        </form>
      </div>
    </Dialog>
  )
}
export default CreateReportModal;
